import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import type { LoadCarrierListItem } from "@msuite/utils/types";
import { OrderFormLoadCarriersHintInput } from "./order-form-load-carriers-hint";
import { OrderFormLoadCarriersQuantityInput } from "./order-form-load-carriers-quantity-input";

const columnHelper = createColumnHelper<LoadCarrierListItem>();

export const columns = [
	columnHelper.display({
		id: "quantity",
		header: localized("general.quantity"),
		cell: (cell) => <OrderFormLoadCarriersQuantityInput item={cell.row.original} />,
		enableSorting: false,
		enableHiding: false,
		enableColumnFilter: false,
	}),
	columnHelper.display({
		id: "hint",
		header: "",
		cell: (cell) => <OrderFormLoadCarriersHintInput item={cell.row.original} />,
	}),
];
